import React, { useEffect, useState } from "react";
import MiniDrawer from "./MiniDrawer.js";
import HomeContainer from "./Home.js";
import SessionsContainer from "./Sessions.js";
import StationContainer from "./Station.js";
import {
  fetchGetRequest,
  fetchPostRequest,
} from "./../config/authentication/AuthService";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import moment from "moment";
import { Auth } from "aws-amplify";
import Header from "./Header.js";

function AppWithData({ handleLogOut }) {
  const [stationGroupIds, setStationGroupIds] = useState("-1");
  const [history, setHistory] = useState({});
  const [sessions, setSessions] = useState({});
  const [lastDataPull, setLastDataPull] = useState("");
  const [issueBanner, setIssueBanner] = useState(false);
  const [stationStatus, setStationStatus] = useState({});
  const [activeSessions, setActiveSessions] = useState({});
  const REQUEST_LIMIT = 1000;
  const MINUTE_MS = 60000;
  function intervalMaker() {
    getBasicData();
    var a = setInterval(function () {
      clearInterval(a);
      intervalMaker();
    }, MINUTE_MS);
  }
  const getBasicData = async () => {
    try {
      // Get Host ID
      let stationGroupIds = "-1";
      try {
        await Promise.all([Auth.currentUserInfo()])
          .then(([currentUserInfo]) => {
            stationGroupIds =
              currentUserInfo.attributes["custom:station_group_ids"];
          })
          .catch((err) => setIssueBanner(true));
        setStationGroupIds(stationGroupIds);
      } catch (err) {
        console.warn(`Failed to retrieve user's station group identification`);
      }
      await Promise.all([_fetchActiveSessions(stationGroupIds)])
        .then(([active]) => {
          try {
            // Sessions (present)
            setActiveSessions(active);
            setLastDataPull(moment.now());
          } catch (err) {
            console.log(err.message);
          }
        })
        .catch((err) => setIssueBanner(true));

      Promise.all([_fetchGetChargingStationsStatus(stationGroupIds)])
        .then(([stationStatus]) => {
          setStationStatus(stationStatus);
        })
        .catch((err) => setIssueBanner(true));

      // Separate the billing history data as it takes signifcantly longer
      Promise.all([_fetchBillingHistory(`count=0`, stationGroupIds)]).then(
        ([countResponse]) => {
          // console.log(
          //   `AppWithData.js - billingHistory to retrieve: ${JSON.stringify(
          //     countResponse
          //   )}`
          // );
          let requestCount = (countResponse / REQUEST_LIMIT).toFixed(0);
          if (countResponse % REQUEST_LIMIT !== 0) requestCount++;
          Promise.all([_getAllBillingHistory(requestCount, stationGroupIds)])
            .then(([billingHistory]) => {
              setHistory(billingHistory);
            })
            .catch((err) => setIssueBanner(true));
        }
      );
    } catch (err) {
      console.error(`AppWithData.js - Error in getBasicData: ${err}`);
    }
  };
  useEffect(() => {
    if (stationGroupIds !== "-1") {
      // Separate the session data as it takes significantly longer
      Promise.all([_fetchGetChargingSessions(`count=0`, stationGroupIds)])
        .then(([countResponse]) => {
          // console.log(
          //   `AppWithData.js - sessionStore to retrieve: ${JSON.stringify(
          //     countResponse
          //   )}`
          // );
          let requestCount = (
            parseInt(countResponse[0].count) / REQUEST_LIMIT
          ).toFixed(0);
          if (parseInt(countResponse[0].count) % REQUEST_LIMIT !== 0)
            requestCount++;
          Promise.all([_getAllSessions(requestCount, stationGroupIds)])
            .then(([res]) => {
              setSessions(res);
            })
            .catch((err) => setIssueBanner(true));
        })
        .catch((err) =>
          console.log(`Could not get count of Charging Sessions`)
        );
    }
  }, [stationGroupIds]);
  useEffect(() => {
    // Get Basic Data for all pages
    intervalMaker();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function _getAllSessions(requestCount, stationGroupIds) {
    let sessionArray = [];
    let res;
    for (let counter = 0; counter < requestCount; counter++) {
      res = await _fetchGetChargingSessions(
        `offset=${counter * REQUEST_LIMIT}&limit=${REQUEST_LIMIT}`,
        stationGroupIds
      );
      // console.log(
      //   `AppWithData.js - getAllSessions offset: ${counter * REQUEST_LIMIT}`
      // );
      if (res.length > 0) sessionArray = [...sessionArray, ...res];
    }
    return sessionArray;
  }
  async function _getAllBillingHistory(requestCount, stationGroupIds) {
    let historyArray = [];
    let res;
    for (let counter = 0; counter < requestCount; counter++) {
      res = await _fetchBillingHistory(
        `offset=${counter * REQUEST_LIMIT}&limit=${REQUEST_LIMIT}`,
        stationGroupIds
      );
      // console.log(
      //   `AppWithData.js - getAllBillingHistory offset: ${counter * REQUEST_LIMIT}`
      // );
      if (res.length > 0) historyArray = [...historyArray, ...res];
    }
    return historyArray;
  }
  async function _fetchGetChargingSessions(params, stationGroupIds) {
    return fetchGetRequest(
      `/stations/metrics?${params}&stationGroupIds=${stationGroupIds}`
    );
  }
  async function _fetchActiveSessions(stationGroupIds) {
    return fetchGetRequest(
      `/sessions/active?stationGroupIds=${stationGroupIds}`
    );
  }
  async function _fetchGetChargingStationsStatus(stationGroupIds) {
    return fetchGetRequest(
      `/stations/status?stationGroupIds=${stationGroupIds}`
    );
  }
  async function _fetchBillingHistory(params, stationGroupIds) {
    return fetchGetRequest(
      `/externalsitehost/billinghistory?${params}&stationGroupIds=${stationGroupIds}`
    );
  }
  return (
    <div
      style={{
        backgroundColor: "#1f2933",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header auth={true} signOut={handleLogOut} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: '100vh'
        }}
      >
        <Router>
          <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/icon?family=Material+Icons"
          />
          <MiniDrawer
            signOut={handleLogOut}
            lastDataPull={lastDataPull}
            issueBanner={issueBanner}
          />
          <Switch>
            <div
              style={{
                display: "flex",
                width: "calc(100% - 225px)",
              }}
            >
              <Route exact path="/">
                <Redirect to="/home" />
              </Route>
              <Route path="/home">
                <HomeContainer
                  active={activeSessions}
                  stationStatus={stationStatus}
                  sessions={sessions}
                  billingHistory={history}
                />
              </Route>
              <Route path="/stations">
                <StationContainer stationStatus={stationStatus} active={activeSessions} />
              </Route>
              <Route path="/sessions">
                <SessionsContainer stationGroupIds={stationGroupIds} />
              </Route>
            </div>
          </Switch>
        </Router>
      </div>
    </div>
  );
}
export default AppWithData;
